// This component is popup which will open when we click on any game in the game list. It will show the setting of that particular game. It has two API calls, first one is to get the setting type of that game and second one is to get the data of that particular setting type. It also has a toggle button to change the status of that setting. It also has an update button to update the data of that setting.

import React, { useEffect, useState } from "react";
import { CommonModal } from "../../shared/Components/Modal";
import InputTable from "../../shared/Components/UI/InputTable";
import {
  getAxios,
  patchAxios,
  postAxios,
} from "../../shared/Services/commonService";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { SubHeading } from "../../shared/Components";
import { Tab, Tabs } from "../../shared/Components/UI/CustomTabs";
import {
  API_BETTINGTYPE_EVENTTYPE_ID,
  API_TOURNAMENT_SETTING,
} from "../../utils/api/ApiConstant";
import { useAccessControl } from "../../shared/Hooks/useAccessControl";

const TournamentSettings = ({ rowData }) => {
  const queryClient = useQueryClient();
  const { hasPermission, isEditSetting } = useAccessControl();
  const [activeSettingType, setActiveSettingType] = useState(null);
  const [isShow, setIsShow] = useState({
    isOpen: false,
    rowData: null,
    updateAll: false,
    name: "",
    modalTitle: "",
    modalContent: null,
    apiFlag: false,
    handleUpdate: null,
  });
  console.log("🚀 rowData:", rowData);

  const eventTypeId = rowData?.eventTypeId;
  const competitionId = rowData?.Id;
  const competitionName = rowData?.Name || "Tournament";

  console.log("competitionId", competitionId, competitionName);

  // First API (Game setting type)
  const { data: eventData, isLoading: eventLoading } = useQuery({
    queryKey: ["gameSettingData", eventTypeId],
    queryFn: () =>
      getAxios(API_BETTINGTYPE_EVENTTYPE_ID, {
        eventTypeId: Number(eventTypeId),
      }),
    enabled: !!eventTypeId, // jab kisi game pr click hoga tab hi chalega.
    refetchOnWindowFocus: false,
    retry: 1,
  });

  //   console.log("eventData", eventData);
  //   console.log("activeSettingType", activeSettingType);

  // Second API (Tournament settings for the selected tab)
  const { data: tournamentData, isLoading: tournamentLoading } = useQuery({
    queryKey: ["tournamentSettingData", competitionId, activeSettingType],
    queryFn: () =>
      getAxios(API_TOURNAMENT_SETTING, {
        competitionId: competitionId,
        bettingTypeId: activeSettingType,
      }),
    enabled: !!competitionId && !!activeSettingType,
  });

  console.log("🚀 ~ tournamentData:", tournamentData);
  // Handle tab change safely
  const handleTabChange = (key) => {
    const selected = Number(key);
    if (selected !== activeSettingType) {
      setActiveSettingType(selected);
    }
  };

  const handleUpdate = async (row) => {
    const payload = {
      ...row,
      competitionSettingId:
        row?.competitionSettingId ||
        row?.bettingTypeSettingId ||
        row?.marketTypeSettingId ||
        row?._id ||
        row?.Id ||
        null,
      competitionId,
      bettingTypeId: activeSettingType,
    };

    const res = await postAxios(API_TOURNAMENT_SETTING, payload);

    if (res) {
      queryClient.invalidateQueries({
        queryKey: ["tournamentSettingData", competitionId, activeSettingType],
      });
    }
  };

  useEffect(() => {
    if (
      !activeSettingType &&
      Array.isArray(eventData) &&
      eventData.length > 0
    ) {
      setActiveSettingType(eventData[0]?.Id);
    }
  }, [eventData, activeSettingType]);

  return (
    <>
      <SubHeading
        eyebrow="Game Settings"
        subTitle={`${competitionName} SETTINGS`}
        isAddBtn={true}
      />
      <div className="card-body">
        <Tabs
          id="controlled-tab-example game-setting-flex"
          activeKey={activeSettingType}
          onSelect={handleTabChange}
          className="tab_bottle"
        >
          {eventData?.map((tab) => (
            <Tab key={tab.Id} eventKey={tab.Id} title={tab.Name} />
          ))}
        </Tabs>

        {/* Table Section */}
        <div className="mt-3">
          {eventLoading ? (
            <p>Loading game setting types...</p>
          ) : !eventData || eventData.length === 0 ? (
            <p>No data available for this sport</p>
          ) : !activeSettingType ? (
            <p>Please select a market type to view data</p>
          ) : tournamentLoading ? (
            <p>Loading tab data...</p>
          ) : Array.isArray(tournamentData) && tournamentData.length > 0 ? (
            <InputTable
              tableData={tournamentData || []}
              onUpdate={handleUpdate}
              canUpdate={isEditSetting}
              handleModal={setIsShow}
            />
          ) : (
            <p>No tournament settings available for this betting type.</p>
          )}
        </div>
      </div>
      {isShow.isOpen && (
        <CommonModal
          isShow={isShow.isOpen}
          // size={isShow.size}
          handleModalHide={() =>
            setIsShow((prev) => ({
              ...prev,
              isOpen: false,
              rowData: {},
              name: "",
            }))
          }
          modalTitle={isShow.modalTitle}
          size={isShow.modalSize}
        >
          {isShow.modalContent &&
            React.createElement(isShow.modalContent, {
              handleShowHide: () =>
                setIsShow((prev) => ({
                  ...prev,
                  isOpen: false,
                  rowData: {},
                  name: "",
                  modalTitle: "",
                })),
              rowData: isShow.rowData,
              updateAll: isShow.updateAll,
              isConfirmed: isShow.isConfirmed,
              handleFn: isShow.handleUpdate,
            })}
        </CommonModal>
      )}
    </>
  );
};

export default TournamentSettings;
